/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc
 */

export const BrandFilterTypename = 'com.hubspot.sales.documents.models.directory.BrandFilter';
export const CreatedByFilterTypename = 'com.hubspot.sales.documents.models.directory.CreatedByFilter';
export const DocumentEntryTypename = 'com.hubspot.sales.documents.models.directory.DocumentEntry';
export const FolderEntryTypename = 'com.hubspot.sales.documents.models.directory.FolderEntry';
export const FolderFilterTypename = 'com.hubspot.sales.documents.models.directory.FolderFilter';
export const TeamFilterTypename = 'com.hubspot.sales.documents.models.directory.TeamFilter';
export const listEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'listEntries',
  auth: 'app',
  fingerprint: 'sU6bllMdYsolUYn-IOAsnpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const countEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'countEntries',
  auth: 'app',
  fingerprint: 'mR1ucKG2D2pDdktfOPVl4JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'searchEntries',
  auth: 'app',
  fingerprint: 'oAAGKRulln0bWz77TvE_e5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const countSearchResultsRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'countSearchResults',
  auth: 'app',
  fingerprint: 'y7ptrL3LtMBDdktfOPVl4JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEntryRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'getEntry',
  auth: 'app',
  fingerprint: 'gf-uyukticELg_lZt2lfKG-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};